import { useCallback } from "react";

/**
 * Custom hook that returns a function to retrieve an error message for a given field.
 *
 * @param {Array} errors - An array of error objects (e.g., from Zod's safeParse result.error.issues).
 * @returns {Function} A function that accepts a field name (dot notation string or array) and returns the corresponding error message.
 */
const useFieldError = (errors) => {
    const getErrorMessage = useCallback(
        (field) => {
            // Convert field to dot-notation string if it's an array
            const fieldKey = Array.isArray(field) ? field.join(".") : field;

            // Find an error object whose path, joined by a dot, matches the fieldKey
            const errorObj = errors.find(
                (err) => err.path && err.path.join(".") === fieldKey
            );
            return errorObj ? errorObj.message : "";
        },
        [errors]
    );

    return getErrorMessage;
};

export default useFieldError;
